import { render, staticRenderFns } from "./ShareForm.vue?vue&type=template&id=2740c8f6&%23default=%7B%20errorMessages%20%7D"
import script from "./ShareForm.vue?vue&type=script&lang=js"
export * from "./ShareForm.vue?vue&type=script&lang=js"
import style0 from "./ShareForm.vue?vue&type=style&index=0&id=2740c8f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports